import {Component, inject, input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {NavigationService} from "../../../../services/navigation.service";

@Component({
  selector: 'app-additional-action-header',
    imports: [
        NgOptimizedImage
    ],
  templateUrl: './additional-action-header.component.html',
  styleUrl: './additional-action-header.component.css'
})
export class AdditionalActionHeaderComponent {
  private navigationService = inject(NavigationService);
  title = input.required()

  back() {
    this.navigationService.navigateBack();
  }
}
